import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Box, Typography } from '@material-ui/core'

import { BaseDialog } from 'components'

import theme from 'theme'

const ConfirmationDialog = ({ open, setOpen }) => {
  const { watch } = useFormContext()

  const contractingParties = watch('contractingParties')
  const contractedParties = watch('contractedParties')
  const contractType = watch('contractType')
  const contractPurpose = watch('contractPurpose')
  const hasClauses = watch('hasClauses')

  const CONTRACT_ITEMS = [
    {
      label: 'Contratantes',
      value: contractingParties?.join(', ') || 'Não informado',
    },
    {
      label: 'Contratados',
      value: contractedParties?.join(', ') || 'Não informado',
    },
    {
      label: 'Tipo de contrato',
      value: contractType || 'Não informado',
    },
    {
      label: 'Finalidade',
      value: contractPurpose || 'Não informado',
    },
    {
      label: 'Possui cláusulas sobre LGPD',
      value: hasClauses || 'Não informado',
    },
  ]

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Revise as informações para continuar"
      closeButtonText="Cancelar"
      actionButtonText="Solicitar Atendimento"
      formRef="contract-solicitation-form"
    >
      <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
        <Typography>
          Confira se todos os dados do contrato estão corretos antes de
          continuar. Você ainda pode voltar e fazer ajustes, se necessário.
        </Typography>
        <Box>
          {CONTRACT_ITEMS.map(({ label, value }) => (
            <Typography gutterBottom key={label}>
              <strong>{label}:</strong> {value}
            </Typography>
          ))}
        </Box>
      </Box>
    </BaseDialog>
  )
}

export default ConfirmationDialog
